import React from 'react';
import { AlertCircle, AlertTriangle, CheckCircle, Info } from 'react-feather';

const ICON = { error: AlertCircle, warn: AlertTriangle, ok: CheckCircle, info: Info };

/**
 * EtlBanner — inline notice inside a step or pane. Replaces the seven
 * different `bg-red-50 dark:bg-red-900/20 border border-red-200 …` blocks
 * that each ETL component grew its own copy of.
 */
export default function EtlBanner({ tone = 'info', title, children, actions }) {
  const Icon = ICON[tone] || Info;
  return (
    <div className={`ep-banner ep-tone-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <Icon size={15} />
      <div className="ep-banner-body">
        {title ? <strong>{title}</strong> : null}
        {title && children ? ' — ' : null}
        {children}
      </div>
      {actions ? <div className="ep-body-head-actions">{actions}</div> : null}
    </div>
  );
}
